var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeComponent === 'main')?_c('ReviewPluginMain',{on:{"setActiveComponent":_vm.setActiveComponent}}):_c('ReviewPluginView',{on:{"setActiveComponent":_vm.setActiveComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }